import { styled, Typography } from '@mui/material';

export const SidebarComponentTitleText = styled(Typography)`
  color: #213b30;
  font-weight: 400;
  opacity: 0.75;
`;
